import { HABIT_COLORS, HABIT_ICONS } from "@/lib/habitColors";

export function AppearancePicker({ color, icon, onChange, idPrefix = "appearance" }) {
  return (
    <div className="space-y-2" data-testid={`${idPrefix}-picker`}>
      <div className="flex flex-wrap gap-1.5">
        {Object.entries(HABIT_COLORS).map(([k, v]) => (
          <button type="button" key={k} onClick={() => onChange({ color: k })} data-testid={`${idPrefix}-color-${k}`} aria-label={k}
            className={`w-7 h-7 rounded-full ${v.dot} transition ${color === k ? "ring-2 ring-offset-2 ring-stone-900 scale-110" : "hover:scale-110"}`} />
        ))}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {Object.entries(HABIT_ICONS).map(([k, I]) => (
          <button type="button" key={k} onClick={() => onChange({ icon: k })} data-testid={`${idPrefix}-icon-${k}`} aria-label={k}
            className={`w-8 h-8 rounded-xl grid place-items-center transition ${icon === k ? (HABIT_COLORS[color] || HABIT_COLORS.amber).solid : "bg-stone-100 text-stone-600 hover:bg-stone-200"}`}>
            <I className="w-4 h-4" />
          </button>
        ))}
      </div>
    </div>
  );
}
